{
  "id": "aphrodite",
  "pantheon": "greeks",
  "name": {
    "pt-BR": "Afrodite",
    "en": "Aphrodite"
  },
  "icon": "gods/aphrodite",
  "portrait": "gods/aphrodite-portrait",
  "age": "heroic",
  "freeUnitsOnAgeUp": {
    "nemean-lion": 1
  },
  "unlocks": [
    "nemean-lion",
    "the-argo",
    "argonauts",
    "divine-blood",
    "golden-apples",
    "roar-of-orthus"
  ],
  "powers": ["curse"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "HeroicAgeAphrodite: CreateUnit NemeanLion at a Temple (one free myth unit), god power Curse (cooldown 150 s); enables the listed unit and techs."
  }
}
